export enum ConversationInitiatorType {
  Buy = 'buy',
  Bundle = 'bundle',
  Message = 'message',
  AskSeller = 'ask_seller',
  BuyerOffer = 'buyer_offer',
  MarkAsSold = 'mark_as_sold',
  Reservation = 'reservation',
  SystemMessage = 'system_message',
  BuyerEntersOfferForm = 'buyer_enters_offer_form',
  SellerEntersNotification = 'seller_enters_notification',
}

export enum ConversationMessageType {
  ActionMessage = 'action_message',
  StatusMessage = 'status_message',
  Message = 'message',
  PortalMessage = 'portal_message',
  OfferMessage = 'offer_message',
  OfferRequestMessage = 'offer_request_message',
  ReportSuggestion = 'report_suggestion',
  AutoReplyFeedbackRequestMessage = 'auto_reply_feedback_request_message',
  ChatbotFeedbackRequestMessage = 'chatbot_feedback_request_message',
  ConversationalChatbotFeedbackRequestMessage = 'conversational_chatbot_feedback_request_message',
}

export enum StatusStyle {
  Gray = 'gray_box',
  Green = 'green_box',
  Red = 'red_box',
  Clear = 'clear_box',
}

export enum StatusIcon {
  Sale = 'sale',
  Shipment = 'shipment',
  Completion = 'completion',
  Failure = 'failure',
}

export enum ConversationLinkActions {
  ShipmentTrackingLink = 'react-shipment-tracking-link',
  BuyerDetailsLink = 'buyer-details-link',
  OfflineVerificationInfoLink = 'react-offline-verification-info-link',
  DropOffPointMapLink = 'react-drop-off-point-map-link',
  ReactElectronicsVerificationInfoLink = 'react-electronics-verification-info-link',
  PickUpParcelLink = 'react-pickup-parcel-link',
}

export enum ComposerType {
  Reply = 'reply',
}

export enum ModeratedItemAvailabilityStatus {
  Visible = 0,
  Hidden = 1,
  Deleted = 2,
  Expired = 3,
}

export enum TransactionSide {
  Buyer = 'buyer',
  Seller = 'seller',
}

export enum TransactionStatus {
  DebitProcessed = 230,
  StatusNew = 1,
  StatusEstimated = 100,
  StatusDebitFailed = 220,
}

export enum ApplicableTransactionAction {
  Offer = 'offer',
  Buy = 'buy',
  RequestOffer = 'request_offer',
  Transfer = 'transfer',
  Reserve = 'reserve',
  WaitingForShipment = 'waiting_for_shipment',
  LeaveFeedback = 'feedback',
}

export enum AdditionalTransactionAction {
  MarkAsSold = 'mark_as_sold',
  MarkAsReceived = 'mark_as_received',
  CanMarkAsReceived = 'can_mark_as_received',
  Bundle = 'bundle',
  UsePayments = 'use_payments',
  DeleteConversation = 'delete_thread',
  Cancel = 'cancel',
  ConfirmShipmentInstructions = 'confirm_shipment_instructions',
  ExtendShippingDeadline = 'extend_shipping_deadline',
  ChangeDeliveryOption = 'change_delivery_option',
}

export enum SafetyFlag {
  EscrowWarning = 1,
}

export enum EscrowBannerTrackingType {
  Warning = 'non_escrow_warning_banner',
  Info = 'non_escrow_info_banner',
}

export enum ItemShippingDetailsDiscountType {
  All = 'all',
  Home = 'home',
  DropOff = 'drop_off',
}

export enum ConversationMessageNewType {
  LegacyMessage = 'legacy_reply',
}

export enum ConversationActionModal {
  CancelTransaction,
  DeleteConversation,
  BlockUser,
  DropOffPoint,
  CarrierChange,
}

export enum BuyButtonPosition {
  ConversationMessageOfferRequest = 'conversation_message_offer_request',
  ConversationMessageOffer = 'conversation_message_offer',
  ConversationHeader = 'conversation_header',
}

export enum ShipmentStatus {
  New = 1,
  Estimated = 100,
  InstructionsConfirmed = 150,
  LabelProcessing = 200,
  LabelFailed = 210,
  LabelProcessed = 220,
  LabelSent = 230,
  TrackingPending = 250,
  Shipped = 300,
  HeldAtPostOffice = 310,
  LostParcel = 350,
  Delivered = 400,
  CancelDone = 500,
  ReturnToSender = 600,
  ReturnToSenderAvailableForPickup = 610,
  CancelFailed = 620,
  ReturnToSenderDelivered = 625,
  ReturnToSenderCompleted = 630,
  ShippedToFacility = 700,
  ArrivedAtFacility = 710,
  VerificationSuccessful = 720,
  VerificationFailed = 730,
  ShippedFromFacility = 740,
}

export enum EducationType {
  None = 'none',
  InConversationSold = 'in_conversation_sold',
  InConversationTransactionCompleted = 'in_conversation_transaction_completed',
  InMessagesSold = 'in_messages_sold',
  InConversationSoldHAOV = 'in_conversation_sold_haov',
  InConversationTransactionCompletedHAOV = 'in_conversation_transaction_completed_haov',
  InConversationSoldElectronics = 'in_conversation_sold_electronics',
  InConversationSoldElectronicsEvs = 'in_conversation_sold_electronics_evs',
  InConversationTransactionCompletedElectronics = 'in_conversation_transaction_completed_electronics',
  InConversationTransactionCompletedElectronicsEvs = 'in_conversation_transaction_completed_electronics_evs',
}

export enum EducationAction {
  Never = 'never',
  Read = 'read',
  Later = 'later',
  GoToSellerPaymentSettings = 'goto_seller_payment_settings',
  GoToMyItems = 'goto_my_items',
  GoToWallet = 'goto_wallet',
  GoToConversation = 'goto_conversation',
  SetupPaypal = 'setup_paypal',
  SendEmail = 'send_email',
  ConfirmRealName = 'confirm_real_name',
}
